import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const action: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const actionIcon: SxStyleFunc<boolean | undefined> = (noData) => ({
  color: (p) => p.palette.grey[700],
  opacity: noData ? '0.3' : 'unset',
  cursor: 'pointer',
});

export const badgePOpover: SxStyle = {
  background: (p) => p.palette.success[200],
  top: 2,
  right: 0,
};

export const network: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(0.5),
  pt: (p) => p.spacing(0.5),
};

export const link: SxStyle = {
  textDecoration: 'none',
  padding: (p) => p.spacing(0.5),
  borderRadius: (p) => p.spacing(0.5),
  transition: 'background-color 0.1s ease',
  ':hover': {
    background: (p) => p.palette.grey[200],
    textDecoration: 'none',
    svg: {
      color: (p) => p.palette.grey[700],
    },
  },
};

export const more: SxStyle = {
  background: (p) => p.palette.primary[100],
  height: (p) => p.spacing(2),
  width: (p) => p.spacing(2),
  borderRadius: '50%',
  display: 'flex',
  verticalAlign: 'center',
  justifyContent: 'center',
  lineHeight: 1,
};

export const badgeWrapper: SxStyle = {
  position: 'relative',
};

export const badgeCountItem: SxStyle = {
  color: (p) => p.palette.primary[500],
  fontSize: (p) => p.spacing(1.25),
};

export const badgeTextPopover: SxStyle = {
  color: (p) => p.palette.success[900],
  fontSize: '8px',
};

export const customPopover: SxStyle = {
  marginTop: 1.5,
  borderRadius: (p) => p.spacing(0.5),
};

export const content: SxStyle = {
  p: 0,
  minWidth: (p) => p.spacing(18.5),
  maxWidth: (p) => p.spacing(22),
};

export const column: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
};

export const popoverWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
};

export const row: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  pl: (p) => p.spacing(0.5),
  height: (p) => p.spacing(4),
  borderRadius: (p) => p.spacing(0.5),
  ':hover': {
    backgroundColor: (p) => p.palette.grey[200],
    cursor: 'pointer',
  },
};

export const titleWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};

export const popoverHeader: SxStyle = {
  lineHeight: 1.5,
  color: (p) => p.palette.grey[700],
  fontSize: (p) => p.spacing(1.25),
  fontWeight: 700,
  p: (p) => p.spacing(1),
};

export const copyIcon: SxStyle = {
  cursor: 'pointer',
  color: (p) => p.palette.grey[500],
};
